import { render, staticRenderFns } from "./port.vue?vue&type=template&id=3b1ad2f1&scoped=true"
import script from "./port.vue?vue&type=script&lang=js"
export * from "./port.vue?vue&type=script&lang=js"
import style0 from "./port.vue?vue&type=style&index=0&id=3b1ad2f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1ad2f1",
  null
  
)

export default component.exports